<template>
    <div div name="pc-connci-sub2" class="pc-barocare-connci-sub2 type-faq">
        <template>
            <BarocareConciHeaderSub />
        </template>
        <div class="sub2-container">
          <div class="main-content">
            <div class="left-sidebar">
                <nav class="navigation">
                    <ul>
                        <li><router-link to="/barocarenew">메인으로</router-link></li>
                        <li><router-link to="/barocarenew/sub2" class="cta_001">서비스 특장점</router-link></li>
                        <li><router-link to="/barocarenew/sub3" class="cta_002">이용방법</router-link></li>
                        <li><router-link to="/barocarenew/sub1" class="cta_003">구매 가능 품목</router-link></li>
                        <li><router-link to="/barocarenew/sub5" class="cta_004">인슐린 약국 찾기</router-link></li>
                        <li class="select"><router-link to="/barocarenew/sub4" class="cta_005">자주 묻는 질문</router-link></li>
                    </ul>
                </nav>
            </div>

            <div class="content">
                <div class="content-header">
                    <div class="content-box sub4">
                    </div>
                    <h2>자주 묻는 질문</h2>
                </div>

                <div class="faq faq-container">
                <dl class="faq-list">
                  <dt :class="{ 'opened': openIndex === 0 }">
                    <button type="button" @click="toggle(0)">
                      <span class="subject">인슐린도 처방이 가능한가요?</span>
                    </button>
                  </dt>
                  <dd v-show="openIndex === 0">
                    <ul>
                      <li>
                        기존에 처방받으신 약품 이름과,  AGP보고서 등을 토대로 의사 진료 후 처방이 가능합니다.           발급된 전자처방전을 약국으로 보내면 약품 수령이 가능합니다.
                      </li>

                    </ul>
                  </dd>
                  <dt :class="{ 'opened': openIndex === 1 }">
                    <button type="button" @click="toggle(1)">
                      <span class="subject">기존에 다니던 병원을 이용할 수 있나요? </span>
                    </button>
                  </dt>
                  <dd v-show="openIndex === 1">
                    <ul>
                      <li>
                       솔닥 컨시어지 서비스는 솔닥과 제휴된 병원만 이용이 가능합니다.
                      </li>
                    </ul>
                  </dd>
                  <dt :class="{ 'opened': openIndex === 2 }">
                    <button type="button" @click="toggle(2)">
                      <span class="subject">처방전을 다른 곳에서 발행받았는데, 소모성재료 구매를 할 수          있나요?</span>
                    </button>
                  </dt>
                  <dd v-show="openIndex === 2">
                    <ul>
                      <li>
                          환자 등록 및 위임 청구 과정을 진행해주시면, 솔닥 컨시어지를 통해 물품을 구매하고          솔닥이 제공하는 각종 혜택을 받을 수 있습니다.
                      </li>
                    </ul>
                  </dd>
                  <dt :class="{ 'opened': openIndex === 3 }">
                    <button type="button" @click="toggle(3)">
                      <span class="subject"
                        >미성년자도 비대면 진료를 받을 수 있나요?</span
                      >
                    </button>
                  </dt>
                  <dd v-show="openIndex === 3">
                    <ul>
                      <li>
                        나이 제한 없이 비대면 진료를 이용할 수 있습니다. 보호자분께서 환자를 보조하여 의사와          대화하는 것도 가능하지만, 진료 중에는 환자가 반드시 함께 있어야 합니다.
                      </li>
                    </ul>
                  </dd>
                  <dt :class="{ 'opened': openIndex === 4 }">
                    <button type="button" @click="toggle(4)">
                      <span class="subject"
                        >홈페이지 물품 목록에 있는 항목만 구매가 가능한가요?</span
                      >
                    </button> 
                  </dt>
                  <dd v-show="openIndex === 4">
                    <ul>
                      <li>
                        홈페이지 목록에서 보이지 않는 소모성재료는 솔닥 컨시어지 고객센터로 문의해주세요.           빠르게 주문 가능 여부를 확인한 후 답변해드리겠습니다.
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>

            <div class="right-sticky-menu box">
                <div class="box-top">
                  <strong><i class="ico-quest"></i>더 궁금한 점이 있나요?</strong>
                  <p>솔닥 컨시어지 상담사와 전화 또는 채팅 상담으로 문의주시면 친절히 답변해 드립니다.</p>
                </div>
                <!-- <div class="box-bot">
                  <div class="left">
                    <strong>솔닥 컨시어지</strong>
                    <span>카카오톡 상담 바로가기</span>
                  </div>
                  <div class="right">
                    <img src="../assets/pc_barocare_conci/img-qr.png" alt="카카오톡 상담 큐알코드">
                  </div>
                </div> -->
            </div>
          </div>
       </div>
    </div>
</template>

<script>
import BarocareConciHeaderSub from '@/components/pc_barocare_conci/BarocareConciHeaderSub';

export default {
    name: 'BarocareConciSub2Pc',
    components: {
        BarocareConciHeaderSub,
    },
    data() {
        return {
            openIndex: 0, // 초기에 아무 항목도 열려있지 않음
            isSubPage: this.$route.path.includes('/sub')
        };
    },
    watch: {
        '$route.path'(newPath) {
            this.isSubPage = newPath.includes('/sub');
        }
    },
    mounted() {
        // 페이지가 로드되면 스크롤을 맨 위로
        $('html').animate({ scrollTop: 0 }, 100);

        // 스크롤 이벤트 리스너 추가
        window.addEventListener('scroll', this.updateActiveSection);
    },
    beforeDestroy() {
        // 컴포넌트 파괴 전 스크롤 이벤트 리스너 제거
        window.removeEventListener('scroll', this.updateActiveSection);
    },
    methods: {
        toggle(index) {
            // 이미 열려 있는 항목을 클릭하면 모두 닫힘
            this.openIndex = this.openIndex === index ? -1 : index;
        },
        scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 77;
                // 스크롤 이동
                window.scrollTo({ top: offsetTop, behavior: 'smooth' });
            }
        },
        updateActiveSection() {
            const sections = document.querySelectorAll('.section');
            const menuItems = document.querySelectorAll('.right-sticky-menu li');
            
            // 모든 메뉴 아이템에서 'selected' 클래스 제거
            menuItems.forEach(item => item.classList.remove('selected'));

            // 가장 가까운 섹션을 추적
            let closestSection = null;
            let minDistance = Infinity; // 윈도우 상단과의 최소 거리

            // 현재 윈도우 상단에 가장 가까운 섹션 찾기
            for (let section of sections) {
                const rect = section.getBoundingClientRect();
                const distanceFromTop = Math.abs(rect.top);
                
                if (distanceFromTop < minDistance) {
                    minDistance = distanceFromTop;
                    closestSection = section;
                }
            }

            // 가장 가까운 섹션에 selected 클래스 추가
            if (closestSection) {
                const sectionId = closestSection.id;
                const activeMenuItem = [...menuItems].find(
                    item => item.querySelector('a').getAttribute('href') === `#${sectionId}`
                );
                
                if (activeMenuItem) {
                    activeMenuItem.classList.add('selected');
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import "../styles/PcBarocareConci.scss";
</style>


// WEBPACK FOOTER //
// src/page/PcBarocareSub4.vue